import { IItemDetail } from 'api/types/marketplace';
import { Context } from 'contexts/ContextProvider';
import { useContext } from 'react';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';

// Static Assets
import Frame456 from '../../../assets/images/frames/frame_456x468@2x.png';
import Frame456Mobile from '../../../assets/images/frames/frame_456x468_mobile@2x.png';
import Frame556 from '../../../assets/images/frames/frame_456x556@2x.png';
import Title2Line from '../../../assets/images/frames/title2line@2x.png';
import PaperOutline from '../../../assets/images/icons/paper_outline@2x.png';
import Frame556Mobile from '../../../assets/images/frames/frame_456x556_mobile@2x.png';

interface Props {
  itemDetailObj: IItemDetail;
  itemRecallRequestHandler: () => void;
  itemRecallRequestLoader: boolean;
  approveTokenHandler: () => void;
  approveTokenLoader: boolean;
  isTokenApproved: boolean;
}

const RecallForm = ({
  itemDetailObj,
  itemRecallRequestHandler,
  itemRecallRequestLoader,
  approveTokenHandler,
  isTokenApproved,
  approveTokenLoader,
}: Props) => {
  const { walletAddress, showLoader, connectWalletHandler } = useContext(Context);

  return (
    <div className={`frame-${!walletAddress ? `456` : `644`}`}>
      <img src={!walletAddress ? Frame456 : Frame556} alt="Frame546" className="img-fluid desktop-visible" />
      <img
        src={!walletAddress ? Frame456Mobile : Frame556Mobile}
        alt="Frame546Mobile"
        className="img-fluid mobile-visible"
      />
      <div className={`frame-${!walletAddress ? `456` : `644`}-wrap`}>
        <div className="title-wrap">
          <img src={Title2Line} alt="Title2Line" className="img-fluid" />
          <h2 className={`title-text disabled`}>{itemDetailObj.title}</h2>
        </div>
        <div className={`frame-${!walletAddress ? `456` : `644`}-content`}>
          <Form name="" className={`form-horizontal`}>
            <FormGroup className={`form-group disabled`}>
              <Label for="Type">Type</Label>
              <Input
                id="Type"
                name="Type"
                placeholder=""
                type="text"
                value={itemDetailObj.type}
                className=""
                disabled
              />
            </FormGroup>

            <FormGroup className={`form-group disabled`}>
              <Label for="priceOfItem" className={`disabled`}>
                MIN BID PRICE
              </Label>
              <div className="form-control-icon disabled">
                <span className="icon-16">
                  <img src={PaperOutline} alt="Paper Outline" className="img-fluid" />
                </span>
                <Input
                  id="priceOfItem"
                  name="priceOfItem"
                  placeholder=""
                  type="text"
                  value={itemDetailObj.bidStartPaper ?? ''}
                  className={`disabled`}
                  disabled
                />
              </div>
            </FormGroup>

            <FormGroup className={`form-group mb-3 disabled`}>
              <Label for="RedeemsAvailable" className={`disabled`}>
                REDEEMS AVAILABLE
              </Label>
              <Input
                id="RedeemsAvailable"
                name="RedeemsAvailable"
                placeholder=""
                type="text"
                value={itemDetailObj.quantity}
                className={`disabled`}
                disabled
              />
            </FormGroup>

            {walletAddress && itemDetailObj.recallItemIds ? (
              <FormGroup className={`form-group mb-3${itemDetailObj.recallItemIds.length < 1 ? ` disabled` : ``}`}>
                <Label for="BidAmountTotal" className={`${itemDetailObj.recallItemIds.length < 1 ? `disabled` : ``}`}>
                  RECALL PAPER BID
                </Label>
                <Input
                  id="BidAmountTotal"
                  name="BidAmountTotal"
                  type="text"
                  value={itemDetailObj.recallBidAmount}
                  className={`${itemDetailObj.recallItemIds.length < 1 ? `disabled` : ``}`}
                  disabled
                />
              </FormGroup>
            ) : null}

            {walletAddress && isTokenApproved ? (
              <Button
                block
                className={`button-bid${itemRecallRequestLoader ? ` is-loading` : ``}`}
                onClick={() =>
                  itemDetailObj.recallBidAmount && itemDetailObj.recallItemIds.length > 0
                    ? itemRecallRequestHandler()
                    : null
                }
                disabled={
                  itemRecallRequestLoader || !itemDetailObj.recallBidAmount || itemDetailObj.recallItemIds.length < 1
                    ? true
                    : false
                }
              >
                RECALL $PAPER BID
              </Button>
            ) : null}

            {!walletAddress ? (
              <Button
                block
                className={`button-bid${showLoader ? ` is-loading` : ``}`}
                onClick={() => connectWalletHandler()}
              >
                CONNECT WALLET
              </Button>
            ) : null}

            {walletAddress && !isTokenApproved ? (
              <Button
                block
                className={`button-bid${approveTokenLoader ? ` is-loading` : ``}`}
                onClick={approveTokenHandler}
              >
                APPROVE
              </Button>
            ) : null}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default RecallForm;
